<template>
  <vs-popup class="wo-rm-stock-item-pop-up"
            title="STOCK ITEMS"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow id="confirm-work-order-pop-up">

      <vx-card no-shadow class="pt-1">
        <div slot="no-body" class="mt-4">
          <h6 class="mb-4">RM STOCK ITEMS</h6>
          <vs-table
            id="sundry-item-list-table"
            :data="rm_stock_items"
            class="table-dark-inverted table-auto vs-con-loading__container">

            <template slot="thead">
              <vs-th width="10%">RM CODE</vs-th>
              <vs-th>DEMAND QUANTITY (KG)</vs-th>
              <vs-th>UNALLOCATED AVAILABLE RM (KG)</vs-th>
              <vs-th>SHORTFALL</vs-th>
              <vs-th>STOCK ALLOCATED RM (KG)</vs-th>
              <vs-th>ON HOLD (KG)</vs-th>
              <vs-th>RM TOTAL ORDER PENDING (KG)</vs-th>
              <vs-th>LATEST RM ORDER DUE DATE & STATUS</vs-th>
              <vs-th>EXPIRED STOCK (KG)</vs-th>
              <vs-th width="15%"></vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" class="text-sm" style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].code">
                  <a @click="onClickViewPredictedReport(data[indextr].code)">{{ data[indextr].code }}</a>
                </vs-td>

                <vs-td :class="`${stockColourClassFactory(data[indextr].stock, data[indextr].demand_quantity ) ? 'text-primary' : 'text-danger'}`" :data="data[indextr].demand_quantity">
                  {{ data[indextr].demand_quantity }}
                </vs-td>

                <vs-td :class="`${stockColourClassFactory(data[indextr].stock, data[indextr].demand_quantity ) ? 'text-primary' : 'text-danger'}`"
                       :data="data[indextr].stock">
                  {{ data[indextr].stock }}
                </vs-td>

                <vs-td>
                  {{ Number(data[indextr].stock) >= Number(data[indextr].demand_quantity) ? '0' : Number(Number(data[indextr].stock) - Number(data[indextr].demand_quantity)).toFixed(4)}}
                </vs-td>

                <vs-td>
                  {{ data[indextr].stock_allocated }}
                </vs-td>

                <vs-td :data="data[indextr].on_hold">
                  {{ data[indextr].on_hold }}
                </vs-td>

                <vs-td :data="data[indextr].rm_on_orders">
                  <div class="flex">
                    {{ data[indextr].rm_on_orders }}
                  </div>
                </vs-td>

                <vs-td>
                  <div class="flex">
                    {{ data[indextr].latest_rm_order.required_by || '' }}
                    {{ data[indextr].latest_rm_order.item_status || '' }}
                    <vx-tooltip v-if="data[indextr].latest_rm_order" :text="`View latest rm order : ${data[indextr].latest_rm_order.purchase_order_code}`">
                        <vs-button @click.stop="onClickViewRmOrder(data[indextr].latest_rm_order.order_id)" size="small" icon-pack="feather" icon="icon-external-link" class="ml-4"></vs-button>
                    </vx-tooltip>
                  </div>
                </vs-td>
                
                <vs-td :data="data[indextr].expired">
                  {{ data[indextr].expired }}
                </vs-td>

                <vs-td>
                  <vs-button size="small" icon-pack="feather" icon="icon-arrow-right" @click.stop="onClickCreatePo(data[indextr].id, data[indextr].demand_quantity)">create PO</vs-button>
                </vs-td>

              </vs-tr>
            </template>


          </vs-table>

          <h6 class="mb-4 mt-8">FG STOCK ITEMS</h6>
          <vs-table
              id="sundry-item-list-table"
              :data="formulation_stock_items"
              class="table-dark-inverted table-auto vs-con-loading__container">

            <template slot="thead">
              <vs-th>FORMULATION CODE</vs-th>
              <vs-th>DEMAND QUANTITY (KG)</vs-th>
              <vs-th>STOCK (KG)</vs-th>
              <vs-th>EXPIRED STOCK (KG)</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :data="tr" class="text-sm" style="cursor: pointer" :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].formulation_code">
                  {{ data[indextr].formulation_code || data[indextr].code }}
                </vs-td>

                <vs-td :class="`${stockColourClassFactory(data[indextr].stock, data[indextr].demand_quantity ) ? 'text-primary' : 'text-danger'}`"
                  :data="data[indextr].demand_quantity">
                  {{ data[indextr].demand_quantity }}
                </vs-td>

                <vs-td :class="`${stockColourClassFactory(data[indextr].stock, data[indextr].demand_quantity ) ? 'text-primary' : 'text-danger'}`"
                  :data="data[indextr].stock">
                  {{ data[indextr].stock }}
                </vs-td>

                <vs-td>
                  {{ data[indextr].expired }}
                </vs-td>

              </vs-tr>
            </template>


          </vs-table>


        </div>
      </vx-card>

    </vx-card>
  </vs-popup>
</template>

<script>
import {RepositoryFactory} from '@/repository/RepositoryFactory'

const ManufacturingRepository = RepositoryFactory.get('manufacturing');

function initialState() {
  return {
    open: false,
    rm_stock_items: [],
    formulation_stock_items: [],
    formulation_id: ''
  }
}

export default {
  name: 'WorkOrderViewRmStockPopUp',
  data() {
    return initialState()
  },
  methods: {
    async openPopup(id) {
      try {
        await Object.assign(this.$data, initialState())
        this.formulation_id = id
        this.rm_stock_items = []
        this.formulation_stock_items = []
        await this.fetchFormulationStock()
        this.open = true
      } catch (e) {

      }
    },
    async fetchFormulationStock() {
      try {
        const { data } = await ManufacturingRepository.getFormulationStockForWorkOrder(this.formulation_id)
        this.formulation_stock_items = data.data.formulation_stock_item
        this.rm_stock_items = data.data.rm_stock_items
      } catch (e) {

      }
    },
    onClickViewPredictedReport(rm_code) {
      this.open = false
      this.$router.push(`/pages/raw-materials?step=2&rm_code=${rm_code}`)
    },
    stockColourClassFactory(stock, demand_quantity) {
      return Number(stock) > Number(demand_quantity)
    },
    onClickCreatePo(rm_id, qty = 0 ) {
      let route = this.$router.resolve({ path: `/pages/raw-materials?step=1&open=${rm_id}&qty=${qty}`});
      window.open(route.href, '_blank');
    },
    onClickViewRmOrder(order_id) {
      let route = this.$router.resolve({ path: `/pages/raw-materials/orders/${order_id}`});
      window.open(route.href, '_blank');
    }
  },
}
</script>

<style scoped>
.wo-rm-stock-item-pop-up >>> .vs-popup {
  /*min-height: 50% !important;*/
  min-width: 55% !important;
}

</style>
